/*
 * Copyright (c) Nexign, JSC, 2023.
 */
/**
 * Page News Manage component
 *
 * @author Evgeniy Naumov
 * @version 1.26.0
 * @since 1.25.1
 */

import { FC, useCallback } from 'react';

import { Button } from '@nexign/scc-ui-kit';
import { useSelector } from 'react-redux';

import { PageTitle } from '@/main/components/common';
import Title from '@/main/components/common/Title/Title';
import { appHistoryPush } from '@/main/modules/app/appHistory';
import PageLocale from '@/main/modules/internationalization/components/PageLocale';
import { TranslationFileNamesEnum } from '@/main/modules/internationalization/constants';
import { makeSelectPageNewsTranslation } from '@/main/modules/internationalization/intSelectors';
import { ECommonTranslationPages } from '@/main/modules/internationalization/types/common/pages';
import { tableDataCountSelector } from '@/main/modules/table/selectors';
import { RoutePath } from '@/main/routes/constants/routesConstants';

import NewsTable from './components/NewsTable/NewsTable';
import { PageNewsManageContainerStyled } from './styled/PageNewsManageStyled';

const PageNewsManage: FC = () => {
    const { manageNews: translation } = useSelector(makeSelectPageNewsTranslation());

    const count = useSelector(tableDataCountSelector);

    const handleCreateNewsBtnClick = useCallback(() => {
        appHistoryPush(RoutePath.newsCreate);
    }, []);

    return (
        <PageNewsManageContainerStyled>
            <PageLocale lazy fileNames={[TranslationFileNamesEnum.pageNews]} />
            <Title pageName={ECommonTranslationPages.news} />
            <PageTitle count={count} title={translation.header.title}>
                <Button size="small" typographyProps={{ variant: 'h5' }} onClick={handleCreateNewsBtnClick}>
                    {translation.header.createNews}
                </Button>
            </PageTitle>
            <NewsTable />
        </PageNewsManageContainerStyled>
    );
};

export default PageNewsManage;
